import http from "@/utils/request";

export const clearEmpty = (data: Object) => {
  const newData = Object.keys(data).reduce(
    (acc, key) => {
      const value = data[key];
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, any>,
  );

  return newData;
};

/**@description 获取媒体信息 */
export const getMediaInfoPlay = (mediaId: string) => http.get(`/space/media/info/play?media_id=${mediaId}`);

/**@description 获取媒体信息 */
export const getMediaInfo = (mediaId: string) => http.get(`/space/media/info?media_id=${mediaId}`);

/**@description 获取oss上传票据 */
export const getOssUploadTicket = (data: any) => http.post(`/space/oss/upload`, { ...data, method: "file" });

/** 获取上传文件信息 */
export const getUploadFileInfo = (data: any) => {
  const { ticket, file } = data;
  const formData = new FormData();
  formData.append("key", `${ticket.dir + file.name}`);
  formData.append("callback", ticket.callback);
  formData.append("OSSAccessKeyId", ticket.accessid);
  formData.append("policy", ticket.policy);
  formData.append("Signature", ticket.signature);
  formData.append("expire", ticket.expire);
  formData.append("success_action_status", "200");
  formData.append("Content-Disposition", `attachment`);
  formData.append("file", file);
  return http.post(ticket.host, formData, {
    timeout: 99999,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**@description 获取oss文件url */
export const getOssFileUrl = (params: any) => http.get(`space/oss/url`,params);
